import { Button } from "@/components/ui/button";
import { TrackerPosition } from "@/interfaces";
import { format } from "date-fns";
import { PlusCircle } from "lucide-react";
import { Marker, Popup } from "react-leaflet";
import { StopIcon } from "../Icons";

interface StopMarkerProps {
  position: TrackerPosition;
  index: number;
  stopsCount: number;
}

const StopMarker = ({ position, index, stopsCount }: StopMarkerProps) => {
  if (!position.stop) return null;

  const driverName = position.driver?.name || "";
  const interval = position.stop_data?.interval || "";

  return (
    <Marker
      key={`stop-${index}`}
      position={[
        position.stop_data!.stop_position_lat,
        position.stop_data!.stop_position_long,
      ]}
      icon={StopIcon(stopsCount.toString())}
      zIndexOffset={9999}
    >
      <Popup>
        <div className="text-sm p-4 w-64">
          <div className="mb-1 text-md font-bold text-center uppercase">
            Parada
          </div>
          <div className="mb-1 text-black">
            Data:{" "}
            {format(
              new Date(position.stop_data!.start_date),
              "dd/MM/yyyy HH:mm:ss",
            )}
          </div>
          <div className="mb-1 text-black">Intervalo: {interval}</div>
          {driverName && (
            <div className="mb-1 text-black">Condutor: {driverName}</div>
          )}
          <div className="mt-2 flex justify-center">
            <Button
              className="p-2 h-7 border border-orange-300 text-orange-300 hover:bg-orange-300 hover:text-white"
              onClick={() => {
                window.open(
                  `/reference-points/create?lat=${position.latitude}&lng=${position.longitude}`,
                  "_blank",
                  "noopener,noreferrer",
                );
              }}
            >
              <PlusCircle />
              Ponto de referência
            </Button>
          </div>
        </div>
      </Popup>
    </Marker>
  );
};

export default StopMarker;
